export default "__VITE_ASSET__38360ff7__"